import React from 'react'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import GradientButton from 'components/common/GradientButton'
import useGlobal from 'hooks/useGlobal'
import useForm from 'hooks/useForm'
import api from 'utils/api'

const useStyles = makeStyles(theme => ({
	button: {
		marginTop: theme.spacing(1),
	},
}))

function LoginForm({ history }) {
	const classes = useStyles()

	const [, authActions] = useGlobal(state => null, actions => actions.auth)
	const { values, errors, setErrors, isSubmitting, setIsSubmitting, handleSubmit, handleChange } = useForm(
		{ username: '', password: '' }, // initialValues
		onSubmit,
		validate
	)

	async function onSubmit() {
		try {
			await api.post('/api/login.php', values)
			authActions.login()
			history.push('/admin')
		} catch (e) {
			setIsSubmitting(false) // 성공한 경우 경로가 변경되므로 reset이나 summit 상태 변경이 필요없다
			const { name, message } = e.response.data
			if (name) {
				setErrors(state => ({ ...state, [name]: message }))
			} else {
				console.log(message)
			}
		}
	}

	function validate(values) {
		let errors = {}
		if (!values.username.trim()) {
			errors.username = '아이디를 입력하세요.'
		}
		if (!values.password.trim()) {
			errors.password = '비밀번호를 입력하세요.'
		}
		return errors
	}

	return (
		<form onSubmit={handleSubmit} noValidate>
			<TextField
				type="text"
				name="username"
				label="아이디"
				placeholder="관리자 아이디"
				margin="normal"
				fullWidth
				autoComplete="email"
				autoFocus
				helperText={errors.username}
				value={values.username}
				error={!!errors.username}
				onChange={handleChange}
			/>
			<TextField
				type="password"
				name="password"
				label="비밀번호"
				placeholder="관리자 비밀번호"
				margin="normal"
				fullWidth
				autoComplete="current-password"
				helperText={errors.password}
				value={values.password}
				error={!!errors.password}
				onChange={handleChange}
			/>
			<GradientButton
				type="submit"
				variant="contained"
				color="primary"
				fullWidth
				disabled={isSubmitting}
				className={classes.button}
			>
				로그인
			</GradientButton>
		</form>
	)
}

export default withRouter(LoginForm)
